module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_tablet-8c5b75fdde827e1a24edbd236f918375.png";